import script from "./DeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteModal.vue?vue&type=style&index=0&id=5ede6f4a&lang=css"
import "./DeleteModal.vue?vue&type=style&index=1&id=5ede6f4a&lang=scss"

const __exports__ = script;

export default __exports__